var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('breadcrumbs',{attrs:{"guia":_vm.guia,"titulo":"Colaboradores","descricao":"Gerencie seus colaboradores e defina as permissões de acesso."}}),_c('v-layout',{staticClass:"main"},[_c('membros')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }